import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from './../../../../themes/default';
import { Card, CardHeader, CardActions, CardContent } from './../../../../themes/cards';

const styles = theme => ({
  root: {
    marginBottom: theme.spacing.unit * 3
  },
  bordered: {
    border: `1px solid ${ theme.palette.grey[300] }`,
    boxShadow: theme.shadows[0]
  }
});

const CardDefault = ({ children, classes, title, subheader, action, footer, bordered }) => {

  return (
    <Card classes={{ root: classNames(  classes.root, bordered ? classes.bordered : null ) }}>

      { (title || subheader) && (
        <CardHeader
          title={ title ? title : null }
          subheader={ subheader ? subheader : null }
          action={ action ? action : null }
        />
      )}

      { children && (
        <CardContent>
          { children }
        </CardContent>
      )}

      { footer && (
        <CardActions>
          { footer }
        </CardActions>
      )}

    </Card>
  )

}

CardDefault.propTypes = {
  children: PropTypes.node
};

export default withStyles(styles)(CardDefault);
